module.exports = __webpack_public_path__ + "static/media/fog-low.7812184c.png";